import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-32">
        <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-ink/50">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-32 pb-32">
        <div className="text-center">
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-terracotta">403</div>
          <div className="font-serif text-4xl text-ink mt-4">Accès réservé à l'administrateur</div>
        </div>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
